'use strict';

(function ($) {

    // Set site colors
    const colors = new Colors();
    $('.header-color').addClass('bg-' + colors.getTopColor());
    $('.header-utilities').addClass('bg-' + colors.getTopColor());
    $('.footer-certificates').addClass('bg-' + colors.getBottomColor());
    $('.footer-links').addClass('bg-' + colors.getBottomColor());


    // Init site selection menu
    const $siteSelection = $('#site-selection');
    $siteSelection.find('> a').click((event) => {
        event.preventDefault();
        $siteSelection.toggleClass('open');
    });

    $(document).on('click', (event) => {
        if (!$(event.target).closest('#site-selection-out').length) {
            $siteSelection.removeClass('open');
        }
    });

    // Init main menu
    const $headerMenuToggle = $('header .menu-toggle > a');
    const $mainMenu = $('#main-menu');
    const $respeutziveMainMenu = $mainMenu.find('nav ul.menu').eq(0);
    const $menuItems = $mainMenu.find('nav > ul > li');
    $menuItems.find('a').on('click', (event) => {
        const $item = $(event.target).parent('li');
        if (!$item.hasClass('menu-item--expanded')) {
            return;
        }
        event.preventDefault();
        if (!$item.hasClass('open')) {
            $menuItems.removeClass('open');
            $item.addClass('open');
        } else {
            $item.removeClass('open');
        }
    });

    $(document).on('click', (event) => {
        if (!$(event.target).closest('#main-menu nav').length && !$(event.target).closest('.menu-toggle').length) {
            if ($respeutziveMainMenu.hasClass('open')) {
              $headerMenuToggle.toggleClass('hidden');
            }
            $respeutziveMainMenu.removeClass('open');
            $menuItems.removeClass('open');
        }
    });

    $headerMenuToggle.click((event) => {
        $respeutziveMainMenu.toggleClass('open');
        $headerMenuToggle.toggleClass('hidden');
    });
})(jQuery);
